// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Zs-z","play":"_s-z"};